import { useMemo } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WalletsResponse } from '../models/Wallets';
import {
  WalletsApiAdapter,
  WalletsFilters,
} from '../adapters/WalletsApiAdapter';

const DEFAULT_FILTERS: WalletsFilters = {};

export const useWallets = (filters?: WalletsFilters) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(() => new WalletsApiAdapter(httpClient), [httpClient]);
  const resolvedFilters = filters ?? DEFAULT_FILTERS;

  return useQuery<WalletsResponse, Error>({
    queryKey: ['wallets', resolvedFilters],
    queryFn: () => apiAdapter.getWallets(resolvedFilters),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
